import { useNavigateBlocker } from '@arc/frontend/util-common';
import { ModalDialog } from './ModalDialog';
export function WarnOnNavAway({
  formState,
  resetForm,
  ...props
}) {
  // formState.isDirty is triggered erroneously sometimes, so we use
  // formState.dirtyFields instead. See:
  // https://github.com/react-hook-form/react-hook-form/issues/10143
  const anyFieldsDirty = Object.keys(formState.dirtyFields).length > 0;
  const blocker = useNavigateBlocker(anyFieldsDirty && !formState.isSubmitSuccessful);
  return <ModalDialog show={blocker.state === 'blocked'} onCancel={() => blocker.reset?.()} onConfirm={() => {
    resetForm?.();
    blocker.proceed?.();
  }} type="discard-changes" {...props} />;
}